import { render, staticRenderFns } from "./EstudioExpress.vue?vue&type=template&id=9a500190&"
import script from "./EstudioExpress.vue?vue&type=script&setup=true&lang=js&"
export * from "./EstudioExpress.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports